import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-filter-timeline',
    templateUrl: './filter-timeline.component.html',
    styleUrls: ['./filter-timeline.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FilterTimelineComponent implements OnInit {

  	@Input() lists: any;
	@Input() filterData:any;

	@Output() notify: EventEmitter<any>  = new EventEmitter<any>();
	@Output() closeView  = new EventEmitter<string>();

	viewFilterData: any = null;

	close(){
		this.closeView.emit()
	}
	
	submitForm(){
		this.notify.emit(this.viewFilterData);
	}

	constructor() { }

	ngOnInit() {
		this.viewFilterData = {...this.filterData};
	}
}
